import React from "react";
import {translate} from "react-i18next";

const Origins = ({t}) => {
    return (
        <div className="history-tab">
            <h4 className="header">{t('about.history.origins.header')}</h4>
            <p>{t('about.history.origins.line1')}</p>
        </div>
    )
}

export default translate('common')(Origins);